import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './CustomToastStyles.css';
import useAuth from './useAuth';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';

function Add_Vehicle_Track() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem('authToken');
    const navigate = useNavigate();
    const [vehicleNumbers, setVehicleNumbers] = useState([]);
    const [vehicleMakes, setVehicleMakes] = useState([]);
    const [error, setError] = useState('');
    const [EmpCode, setEmpCode] = useState('');
    const [uploadError, setUploadError] = useState("");
    const [Grade, setGrade] = useState('');
    const [loading, setLoading] = useState(true);
    const [responseMessage, setResponseMessage] = useState('');
    const [isFileAttached, setIsFileAttached] = useState(false);
    const [branchManagers, setBranchManagers] = useState([]);

    const Loader = () => (
        <div className="loader-container1">
            <div className="spinner1"></div>
            <p>Loading...</p>
        </div>
    );
    const [formData, setFormData] = useState({
        comp_name: '',
        emp_code: '',
        grade: '',
        dept_name: '',
        designation_name: '',
        report_mngr: '',
        bank_acnum: '',
        bank_name: '',
        ifsc_code: '',
        location_name: '',
        vehicle_type: '',
        inhouse_vehicle: '',
        vehicle_number: '',
        driver_name: '',
        driver_mobile: '',
        route_name: '',
        is_submitted: '',
        branch_manager_bmid: '',
        branch_manager_name: '',
        branch_manager_remarks: '',
        branch_manager_approval: 'Pending',
        branch_manager_approved_on: '',
        store_remarks: '',
        OTPverified_on: '',
        img: []
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isFromDraft, setIsFormDraft] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [isSubmitAllowed, setIsSubmitAllowed] = useState(true);
    const [isSavingDraft, setIsSavingDraft] = useState(false);
    const [routeList, setRouteList] = useState([]);
    const [vehicleType, setVehicleType] = useState([]);

    useAuth();  // Custom hook for authentication
    const handleBackClick = () => {
        navigate("/vehicle_tracking");
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'inhouse_vehicle' && value === 'External') {
            //reset vehicle number and type when switching to External
            setFormData(prevState => ({
                ...prevState,
                vehicle_number: '',
                vehicle_type: ''
            }));
        }

        if (name === 'vehicle_number' && value) {
            const vehicle = vehicleNumbers.find(v => v.vehicle_number === value);
            if (vehicle) {
                setFormData(prevState => ({
                    ...prevState,
                    [name]: value,
                    vehicle_type: vehicle.vehicle_type
                }));
                return;
            }
        }

        // Validate driver mobile number
        if (name === 'driver_mobile' && value) {
            // Only validate if 10 digits have been entered
            if (value.length === 10 && !validateMobile(value)) {
            toast.error("Please enter a valid mobile number.");
            return;
            }
        }

        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    //validate driver mobile number
    const validateMobile = (number) => {
        // Example: Validate 10-digit Indian mobile numbers
        const mobileRegex = /^[6-9]\d{9}$/;
        return mobileRegex.test(number);
    };

    // getVehicleTypes
    useEffect(() => {
        const fetchVehicleTypes = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}getVehicleTypes`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                if (result.status) {
                    console.log("Vehicle types:", result.data); // Log to check fetched data
                    setVehicleType(result.data);
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError('Failed to fetch items');
            } finally {
                setLoading(false);
            }
        }
        fetchVehicleTypes();
    }, []);


    useEffect(() => {
        const fetchProfileData = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${API_BASE_URL}profile`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                console.log("Profile data:", result); // Log to check fetched data

                if (result.status) {
                    const { profile } = result;

                    // Set default values from profile
                    setEmpCode(profile.emp_code || '');
                    setGrade(profile.grade || '');
                    setFormData(prevData => ({
                        ...prevData,
                        comp_name: profile.comp_name || '',
                        emp_code: profile.emp_code || '',
                        dept_name: profile.dept_name || '',
                        designation_name: profile.designation_name || '',
                        grade: profile.grade || '',
                        report_mngr: profile.report_mngr || '',
                        mobile: profile.mobile || '', // Do not display the password
                        bank_acnum: profile.bank_acnum || '',
                        bank_name: profile.bank_name || '',
                        ifsc_code: profile.ifsc_code || '',
                        location_name: profile.location_name || '',
                    }));
                } else {
                    setResponseMessage('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchProfileData();
    }, []);

    useEffect(() => {
        setLoading(true);
        const fetchVehicleNumbers = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}getVehicleNumbers`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                console.log("Vehicle numbers:", result); // Log to check fetched data
                if (result.status) {
                    setVehicleNumbers(result.data);
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError('Failed to fetch items');
            } finally {
                setLoading(false);
            }
        };
        fetchVehicleNumbers();
    }, []);

    useEffect(() => {
        setLoading(true);
        const fetchBranchManagers = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}getemployee`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const result = await response.json();
                console.log("Branch managers:", result); // Log to check fetched data
                if (result.status) {
                    setBranchManagers(result.data);
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError('Failed to fetch items');
            } finally {
                setLoading(false);
            }
        };
        fetchBranchManagers();
    }, []);


    useEffect(() => {
        setLoading(true);
        const fetchRoutes = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}get_routes`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                });

                const data = await response.json();
                if (data.status && Array.isArray(data.data)) {
                    setRouteList(data.data);
                }
            } catch (err) {
                console.error("Error fetching routes:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchRoutes();
    }, []);

    const handleSubmit = async () => {
        // Validation check
        if (!formData.vehicle_number) {
            toast.error("Please select a vehicle number.");
            return;
        } else if (!formData.vehicle_type) {
            toast.error("Please select a vehicle type.");
            return;
        } else if (!formData.driver_name) {
            toast.error("Please enter driver name.");
            return;
        } else if (!formData.driver_mobile) {
            toast.error("Please enter driver mobile number.");
            return;
        } else if (!formData.route_name) {
            toast.error("Please select a route name.");
            return;
        }

        try {
            setIsSubmitting(true);

            // Validate required fields
            // if (!formData.branch_manager_bmid) {
            // toast.error("Please select a Branch Manager");
            // return;
            // }

            // Get branch manager name
            // const selectedBranchManager = branchManagers.find(manager => manager.emp_code === formData.branch_manager_bmid);


            // Update form data with branch manager details
            const updatedFormData = {
                ...formData,
                // branch_manager_name: selectedBranchManager.comp_name,
                // branch_manager_bmid: formData.branch_manager_bmid,
                img: formData.img || [] // Ensure img array exists
            };

            const response = await fetch(`${API_BASE_URL}add_vehicle_track`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(updatedFormData)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.status) {
                toast.success(formData.is_submitted === 'Yes' ?
                    "Vehicle tracking form submitted successfully!" :
                    "Draft saved successfully!");
                navigate("/edit_vehicle_tracking/" + result.data);
            } else {
                toast.error(result.message || "Operation failed");
            }

        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred: " + error.message);
        } finally {
            setIsSubmitting(false);
            setIsSavingDraft(false);
        }
    };





    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const MAX_SIZE = 1 * 1024 * 1024; // 1MB in bytes

        let errorMsg = "";
        const validFiles = files.filter(file => {
            if (file.size > MAX_SIZE) {
                errorMsg = `File "${file.name}" exceeds the 1MB limit. Please upload a smaller file.`;
                return false;
            }
            return true;
        });

        if (errorMsg) {
            setUploadError(errorMsg); // Show error message above button
            toast.error(errorMsg); // Also show toast
            setIsSubmitAllowed(false); // Prevent submission
        } else {
            setUploadError(""); // Clear error if no issue
            setIsSubmitAllowed(true); // Allow submission
        }

        if (validFiles.length === 0) return; // Stop if all files are invalid

        // Convert valid files to Base64
        const fileReaders = validFiles.map(file => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        });

        Promise.all(fileReaders)
            .then(base64Files => {
                setFormData(prevData => ({
                    ...prevData,
                    img: base64Files
                }));
                setIsFileAttached(true); // Set flag to true if files are attached
            })
            .catch(error => {
                console.error("Error reading files:", error);
            });
    };


    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0" style={{ fontSize: '20px' }}>Add Vehicle Tracking Form</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
                                        <li className="breadcrumb-item active">New Vehicle Tracking Form</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <Loader /> // Show loader if loading is true
                    ) : (
                        <>
                            <section className="col-lg-12">
                                <div className="card" style={{ borderTop: '3px solid #CC5500' }}>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit} method="post" acceptCharset="utf-8">
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <div className="box-body">
                                                    {/* <div className="row">
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Employee No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="emp_code"
                                                                    id="name"
                                                                    value={formData.emp_code}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Employee No/Consultant"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Name </label>
                                                                <input
                                                                    type="text"
                                                                    name="comp_name"
                                                                    id="name"
                                                                    value={formData.comp_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Name"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Employee Band</label>
                                                                <input
                                                                    type="text"
                                                                    name="grade"
                                                                    id="name"
                                                                    value={formData.grade}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Department</label>
                                                                <input
                                                                    type="text"
                                                                    name="dept_name"
                                                                    id="name"
                                                                    value={formData.dept_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Designation </label>
                                                                <input
                                                                    type="text"
                                                                    name="designation_name"
                                                                    id="name"
                                                                    value={formData.designation_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Mobile No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="mobile"
                                                                    id="name"
                                                                    value={formData.mobile}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                    {/* <div className="row">
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="bank_name">Bank Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_name"
                                                                    id="bank_name"
                                                                    value={formData.bank_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="bank_acnum">Bank Ac.No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_acnum"
                                                                    id="bank_acnum"
                                                                    value={formData.bank_acnum}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="ifsc_code">IFSC Code
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="ifsc_code"
                                                                    id="ifsc_code"
                                                                    value={formData.ifsc_code}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Reporting Manager
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="report_mngr"
                                                                    id="name"
                                                                    value={formData.report_mngr}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Location
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="location_name"
                                                                    id="name"
                                                                    value={formData.location_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                       


                                                    </div> */}
                                                    <div className="row">
                                                        {/* <div className="col-md-2">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Branch Manager
                                                                    </label>
                                                                    <select
                                                                        name="branch_manager_bmid"
                                                                        id="branch_manager_bmid"
                                                                        value={formData.branch_manager_bmid}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"
                                                                        required
                                                                    >
                                                                        <option value="">-- Select --</option>
                                                                        {branchManagers.map((item, index) => (
                                                                            <option key={index} value={item.emp_code}>
                                                                                {item.comp_name} ({item.emp_code})
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div> */}

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label>Inhouse Vehicle </label>
                                                                <select
                                                                    name="inhouse_vehicle"
                                                                    id="inhouse_vehicle"
                                                                    value={formData.inhouse_vehicle}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                >
                                                                    <option value="">-- Select --</option>
                                                                    <option value="InHouse">InHouse</option>
                                                                    <option value="External">External</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="vehicle_number">Vehicle Number
                                                                </label>
                                                                {formData.inhouse_vehicle === "External" ? (
                                                                    <input
                                                                        type="text"
                                                                        name="vehicle_number"
                                                                        id="vehicle_number"
                                                                        value={formData.vehicle_number}
                                                                        placeholder='Enter Vehicle Number'
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"
                                                                        required
                                                                    />)
                                                                    :
                                                                    <select
                                                                        name="vehicle_number"
                                                                        id="vehicle_number"
                                                                        value={formData.vehicle_number}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"
                                                                        required
                                                                    >
                                                                        <option value="">-- Select --</option>
                                                                        {vehicleNumbers.map((item, index) => (
                                                                            <option key={index} value={item.vehicle_number}>
                                                                                {item.vehicle_number}
                                                                            </option>
                                                                        ))}
                                                                    </select>}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="vehicle_type">Vehicle Type</label>
                                                                {formData.inhouse_vehicle === "External" ? (
                                                                    <select
                                                                        name="vehicle_type"
                                                                        id="vehicle_type"
                                                                        value={formData.vehicle_type}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"
                                                                        required
                                                                    >
                                                                        <option value="">-- Select --</option>
                                                                        {vehicleType.map((item, index) => (
                                                                            <option key={index} value={item.vehicle_type}>
                                                                                {item.vehicle_type}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                ) : (
                                                                    <select
                                                                        name="vehicle_type"
                                                                        id="vehicle_type"
                                                                        value={formData.vehicle_type}
                                                                        onChange={handleChange}
                                                                        className="form-control input-font"
                                                                        required
                                                                    >
                                                                        <option value="">-- Select --</option>
                                                                        {vehicleType
                                                                            .filter(type => {
                                                                                if (!formData.vehicle_number) return true;
                                                                                const vehicle = vehicleNumbers.find(v =>
                                                                                    v.vehicle_number === formData.vehicle_number
                                                                                );
                                                                                return vehicle ? type.vehicle_type === vehicle.vehicle_type : false;
                                                                            })
                                                                            .map((item, index) => (
                                                                                <option key={index} value={item.vehicle_type}>
                                                                                    {item.vehicle_type}
                                                                                </option>
                                                                            ))}
                                                                    </select>
                                                                )}
                                                            </div>
                                                        </div>



                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="driver_name">Driver Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="driver_name"
                                                                    id="driver_name"
                                                                    value={formData.driver_name}
                                                                    placeholder='Enter Driver Name'
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    required
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="driver_mobile">Driver Mobile
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="driver_mobile"
                                                                    id="driver_mobile"
                                                                    placeholder='Enter Driver Mobile'
                                                                    value={formData.driver_mobile}                                                                        
                                                                        onChange={(e) => {
                                                                            handleChange(e);                                                                            
                                                                        }}
                                                                        onBlur={(e) => {
                                                                            if (e.target.value.length < 10) {
                                                                                toast.error("Please enter a valid 10-digit mobile number.");
                                                                            }
                                                                        }}
                                                                    className="form-control input-font"
                                                                    pattern="[0-9]{10}"
                                                                    maxLength="10"
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="driver_licence">Remarks </label>
                                                                <textarea
                                                                    name="store_remarks"
                                                                    id="store_remarks"
                                                                    value={formData.store_remarks}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    rows="1"
                                                                    required
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row"> 
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="route_name"> Route
                                                                </label>

                                                                <select
                                                                    name="route_name"
                                                                    id="route_name"
                                                                    value={formData.route_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    required
                                                                >
                                                                    <option value="">-- Select --</option>
                                                                    {routeList.map((item, index) => (
                                                                        <option key={index} value={item.route_name} style={{whiteSpace: 'pre-line'}}>
                                                                            {item.route_name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                    {formData.route_name && (
                                                                        <div className='mt-2'>
                                                                            <span>Branches:</span>
                                                                            <ul>
                                                                                {(routeList.find(r => r.route_name === formData.route_name)?.branch_ids || '')
                                                                                    .toString()
                                                                                    .split(",")
                                                                                    .filter(id => id)
                                                                                    .map(id => (
                                                                                        <li key={id.trim()}>{id.trim()}</li>
                                                                                    ))}
                                                                            </ul>
                                                                        </div>
                                                                    )}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>


                                            <section className="col-lg-12">
                                                {uploadError && <div className="alert alert-danger text-center p-2">{uploadError}</div>}

                                                <label className="font-weight-bold">Upload Multiple Images:</label>
                                                <div className="custom-file mb-3">
                                                    <input
                                                     type="file"
                                                        name="img"
                                                        multiple
                                                        accept="image/jpeg,image/jpg,image/png,application/pdf"
                                                        className="form-control"
                                                        onChange={handleFileChange}
                                                        max="5" // Limit to 5 files
                                                    />
                                                    <small className="form-text text-muted">
                                                        Allowed formats: JPG, JPEG, PNG, PDF. Max size: 1MB per file. Max 5 files.
                                                    </small>
                                                </div>

                                                {isFileAttached && formData.img.length > 0 && (
                                                    <div className="mt-2">
                                                        <span className="text-success">
                                                            <i className="fas fa-check-circle"></i> {formData.img.length} file(s) attached successfully!
                                                        </span>
                                                        <div className="mt-2">
                                                            {formData.img.map((file, index) => (
                                                                <span key={index} className="badge badge-info mr-2">
                                                                    File {index + 1}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}

                                                <center className="mt-4">
                                                    {/* Save as Draft Button */}
                                                    <button
                                                        type="button"
                                                        className="btn btn-warning"
                                                        onClick={() => {
                                                            formData.is_submitted = 'No';
                                                            setIsFormDraft(true);
                                                            handleSubmit();
                                                        }}
                                                    >
                                                        Save as Draft
                                                    </button>
                                                    {/* Submit Button */}



                                                    <button
                                                        type="button"
                                                        className="btn btn-success ml-3"
                                                        onClick={() => {
                                                            formData.is_submitted = 'Yes'; // Directly update formData
                                                            setFormData({ ...formData }); // Update state to trigger re-render
                                                            setIsFormSubmitted(true);
                                                            handleSubmit();
                                                        }}
                                                        disabled={isFileAttached && formData.img.length > 0 ? false : true}
                                                    >
                                                        {isSubmitting ? 'Submitting...' : 'Submit'}
                                                    </button>
                                                    {/* Cancel Button */}
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary ml-3"
                                                        onClick={handleBackClick}
                                                    >
                                                        Cancel
                                                    </button>
                                                </center>
                                            </section>

                                        </form>
                                    </div>
                                </div>
                            </section>
                        </>
                    )}
                </div>
                <Footer />
            </div>
            <ToastContainer />
        </div>
    )
}

export default Add_Vehicle_Track